

































































































































import { Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";

import SelectUsers from "@/components/selectusers.vue";

import Add from "./Add.vue";

import AddPhrase from "./push_phrase_add.vue";

@Component({
  components: {
    SelectUsers,
    Add,
    AddPhrase,
  },
})
export default class extends Mixins(MyList) {
  phraseModalVisible: boolean = false;
  content: string = "";

  dispatchType = "message/adminpush";
  // dispatchTypeDelete: string = 'setting/delete'
  // deleteConfirmContent: string = '确认要删除该配置吗？'
  // page: number = 10
  // page_size: number = 10

  editData: any = {};

  // 操作搜索栏的展开和折叠
  isFlag = false;

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id",
    },
    {
      title: "应用",
      scopedSlots: { customRender: "to_user_type" },
    },
    {
      title: "接收人",
      scopedSlots: { customRender: "to_user_id" },
    },
    {
      title: "标题",
      dataIndex: "title",
    },
    {
      title: "内容",
      scopedSlots: { customRender: "content" },
    },
    {
      title: "时间",
      dataIndex: "created_time",
    },
    {
      title: "操作",
      width: 150,
      scopedSlots: { customRender: "action" },
    },
  ];

  showPhraseModal(content: string) {
    this.content = content;
    this.phraseModalVisible = true;
  }

  hidePhraseModal() {
    this.phraseModalVisible = false;
  }

  mounted() {
    // this.searchData.msg_types = [2, 3, 4, 5]
    this.loadData();
  }

  showEditModal1(id: number, record: any) {
    this.editId = id;
    this.editData = record;
    this.editModalVisible = true;
  }
}
